// LICENSE PROTECTED SOFTWARE
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'cookie_consent';

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) setShow(true);
    } catch (_) { /* noop */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() })); } catch(_){}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 bg-white border border-slate-200 rounded-2xl shadow-2xl p-5"
         role="dialog" aria-label="Çerez bilgilendirmesi" data-testid="cookie-banner">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
          <Cookie className="w-5 h-5 text-amber-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-slate-900 text-sm mb-1">Çerez Kullanımı</h3>
          <p className="text-xs text-slate-600 leading-relaxed">
            Bu site oturum güvenliği için <strong>zorunlu çerezler</strong> kullanır. Analitik veya reklam çerezi yoktur.
            Detaylar: <Link to="/cerez-politikasi" className="text-blue-600 hover:underline">Çerez Politikası</Link> ·
            {' '}<Link to="/gizlilik-bildirimi" className="text-blue-600 hover:underline">KVKK</Link>
          </p>
          <button onClick={accept} data-testid="cookie-accept-btn"
            className="mt-3 inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white text-xs font-medium px-4 py-2 rounded-lg transition">
            Anladım
          </button>
        </div>
        <button onClick={accept} className="text-slate-400 hover:text-slate-600" aria-label="Kapat" data-testid="cookie-close-btn">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
